export default __webpack_public_path__ + "static/media/loading.71f4943d.gif";